/**
 * @generated SignedSource<<b7da52a94d0c2d5e000ec20c1fb29fe1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type LANGUAGE = "ENGLISH_US" | "ENGLISH_UK" | "ENGLISH_EU" | "SPANISH" | "DANISH" | "POLISH" | "FRENCH" | "%future added value";
export type SEAT_TYPE = "VIRTUAL" | "COLLABORATOR" | "CORE" | "FULL" | "%future added value";
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type appv2_viewer$data = {
  readonly id: string;
  readonly backendId: number | null;
  readonly csrfToken: string | null;
  readonly actualPersonId: string | null;
  readonly permissions: ReadonlyArray<string | null> | null;
  readonly profiles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly seat: SEAT_TYPE | null;
      } | null;
    } | null> | null;
  } | null;
  readonly hasAcceptedTerms: boolean | null;
  readonly downForMaintenance: boolean | null;
  readonly availableFeatureFlags: ReadonlyArray<{
    readonly key: string | null;
  } | null> | null;
  readonly email: string | null;
  readonly language: LANGUAGE | null;
  readonly company: {
    readonly id: string;
    readonly accessBlocked: boolean | null;
    readonly trialEndTime: string | null;
    readonly tier: TierType | null;
    readonly modules: ReadonlyArray<{
      readonly endYear: number | null;
      readonly endMonth: number | null;
      readonly endDay: number | null;
      readonly moduleType: string | null;
    } | null> | null;
    readonly availableMLModels: {
      readonly lowHighModel: boolean | null;
      readonly overrunModel: boolean | null;
      readonly roleModel: boolean | null;
      readonly assigneeModel: boolean | null;
      readonly labelModel: boolean | null;
    } | null;
    readonly timeRegistrationSettings: {
      readonly granularity: string | null;
      readonly allowDoneTasks: boolean | null;
      readonly allowProjects: boolean | null;
      readonly allowInternalTime: boolean | null;
      readonly allowBillableSplit: boolean | null;
      readonly allowRoles: boolean | null;
      readonly allowExceedingEstimate: boolean | null;
      readonly allowOutsideTaskDates: boolean | null;
      readonly allowOutsideProjectDates: boolean | null;
      readonly requireTaskAssignment: boolean | null;
      readonly requireNote: boolean | null;
    } | null;
    readonly revenueEnabled: boolean | null;
    readonly timesheetsEnabled: boolean | null;
    readonly clientsEnabled: boolean | null;
    readonly weekendDisplayPerUser: boolean | null;
    readonly weekendDisplayShowAlways: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectStages_company">;
  } | null;
  readonly " $fragmentType": "appv2_viewer";
};
export type appv2_viewer$key = {
  readonly " $data"?: appv2_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"appv2_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appv2_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backendId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "csrfToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "ProfileTypeConnection",
      "kind": "LinkedField",
      "name": "profiles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Profile",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "seat",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "profiles(first:1)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAcceptedTerms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downForMaintenance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeatureFlag",
      "kind": "LinkedField",
      "name": "availableFeatureFlags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectStages_company"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accessBlocked",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "trialEndTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Module",
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "moduleType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AvailableMLModels",
          "kind": "LinkedField",
          "name": "availableMLModels",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lowHighModel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "overrunModel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "roleModel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "assigneeModel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "labelModel",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeRegistrationSettingsType",
          "kind": "LinkedField",
          "name": "timeRegistrationSettings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "granularity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowDoneTasks",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowProjects",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowInternalTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowBillableSplit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowRoles",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowExceedingEstimate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowOutsideTaskDates",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowOutsideProjectDates",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requireTaskAssignment",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requireNote",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "revenueEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timesheetsEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clientsEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weekendDisplayPerUser",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weekendDisplayShowAlways",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "2d259d45b4f8bed240eb994cce45bc11";

export default node;
